module.exports = __webpack_public_path__ + "img/asliri.f0ecb5a2.jpeg";